import { Component } from 'react';
import { Avatar, Tip } from '@beisen/chaos-ui';

class DragCell extends Component {
    constructor(props) {
        super(props);
    }

    touchStartHandler() {
        const obj = this.dragObj;
        const touch = event.targetTouches[0];
        /* 拖动过程中 手指相对拖动obj的位置是不会变的
            在此记录手指在obj内的x\y距离
        */
        this.disX = touch.clientX - obj.offsetLeft;
        this.disY = touch.clientY - obj.offsetTop;
        // 拖动对象的宽高
        this.oWidth = obj.offsetWidth;
        this.oHeight = obj.offsetHeight;
        // 可拖动区域的宽高
        this.pWidth = this.props.getContainer().width;
        this.pHeight = this.props.getContainer().height;

        this.timeout = setTimeout(event => {
            // 手指保持不动超过150ms后，可开始移动
            this.start = true;
            obj.style.boxShadow = '0 2px 6px 0 rgba(0,0,0,0.15)';
        },150);
    }

    touchMoveHandler() {
        if(!this.start) {
            clearTimeout(this.timeout);
            this.start = false;
            return;
        }
        const touch = event.targetTouches[0];
        this.move = true;
        event.preventDefault();
        // 移动时关闭tip
        this.props.closeTip && this.props.closeTip();
        const obj = this.dragObj;
        
        obj.style.zIndex = 1;
        obj.style.left = touch.clientX - this.disX  + 'px';
        obj.style.top = touch.clientY - this.disY + 'px';
        //左侧边界
        if(obj.offsetLeft <= 0) {
            obj.style.left = 0;
        };
        //右侧边界
        if(obj.offsetLeft >= this.pWidth - this.oWidth) {
            obj.style.left =  this.pWidth - this.oWidth + 'px';
        };
        //上面边界
        if(obj.offsetTop <= 0) {
            obj.style.top = 0;
        };
        //下面边界
        if(obj.offsetTop >= this.pHeight - this.oHeight) {
            obj.style.top =  this.pHeight - this.oHeight + 'px';
        };

        this.currentItem = {
            cell: obj
            ,pointX: touch.clientX
            ,pointY: touch.clientY
            ,index: this.props.index
        };
        // 移动时经过的格子样式
        this.props.overCellStyle && this.props.overCellStyle(this.currentItem);
    }

    touchEndHandler() {
        const obj = this.dragObj;
        obj.style.zIndex = 0;
        obj.style.boxShadow = '0 2px 6px 0 rgba(0,0,0,0)';
        if(!this.move) {
            clearTimeout(this.timeout);
            this.start = false;
            return;
        }
        clearTimeout(this.timeout);
        this.start = false;
        this.move = false;
        // 最终移动到某格
        this.props.moveToCell && this.props.moveToCell(this.currentItem);
    }

    registerTouchStartEvent() {
        this.dragObj = this.refs.dragBox;
        if(this.dragObj) {
            this.dragObj.addEventListener('touchstart',e => {
                this.touchStartHandler(e);
            },false);
            this.registedTouchStartEvent = true;
        }
    }

    registerTouchMoveEvent() {
        if(this.dragObj) {
            this.dragObj.addEventListener('touchmove',e => {
                this.touchMoveHandler(e);
            },false);
            this.registedTouchMoveEvent = true;
        }
    }

    registerTouchEndEvent() {
        if(this.dragObj) {
            this.dragObj.addEventListener('touchend',e => {
                this.touchEndHandler(e);
            },false);
            this.registedTouchEndEvent = true;
        }
    }

    componentDidMount() {
        this.registerTouchStartEvent();
        this.registerTouchMoveEvent();
        this.registerTouchEndEvent();
    }

    componentDidUpdate() {
        if(!this.registedTouchStartEvent) {
            this.registerTouchStartEvent();
        }
        if(!this.registedTouchMoveEvent) {
            this.registerTouchMoveEvent();
        }
        if(!this.registedTouchEndEvent) {
            this.registerTouchEndEvent();
        }
    }

    componentWillUnmount() {
        this.dragObj.removeEventListener('touchstart',() => {
            this.touchStartHandler();
        },false);
        this.dragObj.removeEventListener('touchmove',() => {
            this.touchMoveHandler();
        },false);
        this.dragObj.removeEventListener('touchend',() => {
            this.touchEndHandler();
        },false);
    }

	render() {
        const { data,translation } = this.props;
        if(data) {
            let avatars = data.UserAvatar, Avatars = {};
            if (avatars) {
                for (let key in avatars) {
                    let newKey = key.substring(0, 1).toLowerCase() + key.substring(1);
                    Avatars[newKey] = avatars[key];
                }
            }
            const userInfo = {
                Id: data.Id
                , Name: data.Name
                , avatars: Avatars
                , Email: data.Email
            };
			return (<div className="box-space">
                        <div ref="dragBox" className="drag-box border-1px" >
                            {this.props.index == 0 ? <Tip msg={translation.dragCellTipMsg} show={this.props.showTip} onTapClose={this.props.closeTip} boxStyle={{ left: '-70px', top: '-40px' }} iconStyle={{ left: '98px' }} /> : null}
                            <Avatar cls='drag-icon' scale='big' {...userInfo} />
                            <div className='drag-icon-text bg-1'>{data.Name}</div>
                        </div>
                    </div>);
		}
		return <div className='box-space'></div>;
	}
}
export default DragCell;


// WEBPACK FOOTER //
// ./src/components/Field_Components/Staff/DragGrid/DragCell.js